"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenButton = exports.VideoPopUpWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const PopUp_elements_1 = require("@components/common/PopUp/PopUp.elements");
exports.VideoPopUpWrap = styled_components_1.default.div `
  ${PopUp_elements_1.Body} {
    //min-height: 620px;
    width: fit-content;
  }

  ${PopUp_elements_1.Content} {
    //min-height: 514px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 50px;
    text-wrap: nowrap;
    width: 100%;
  }
`;
exports.OpenButton = styled_components_1.default.a `
  font-family: "GolosTextWebRegular", sans-serif;
  text-transform: uppercase;
  text-decoration: none;
  border: 3px solid #6e77fb;
  padding: 11px;
  width: fit-content;
  margin: 20px 0;
  font-size: 18px;
  color: #6e77fb;
  background-color: white;
  cursor: pointer;
  border-radius: 50px;
  text-align: center;
`;
